import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Jahresauswahl fuer Stundenzettel: nie hart verdrahten, sonst faellt die App zum
// Jahreswechsel aus. Das FOLGEjahr ist bewusst dabei - der Dezember-Zettel wird im
// Januar eingereicht, und ein Januar-Zettel muss vorher anlegbar sein.
// Vor 2024 gibt es keine Daten, deshalb die harte Untergrenze.
export const ERSTES_JAHR = 2024;

export function verfuegbareJahre(heute = new Date()) {
  const jahr = heute.getFullYear();
  const jahre = [];
  for (let j = jahr - 2; j <= jahr + 1; j++) {
    if (j >= ERSTES_JAHR) jahre.push(j);
  }
  return jahre;
}

// Wo liegt der angezeigte Monat im Verhaeltnis zu heute? (Auftrag 05)
// 'aktuell' | 'vormonat' | 'sonstiges' - nur 'sonstiges' wird gewarnt.
export function monatsEinordnung(monat, jahr, heute = new Date()) {
  const jetzt = heute.getFullYear() * 12 + heute.getMonth();
  const gewaehlt = jahr * 12 + (monat - 1);
  if (gewaehlt === jetzt) return 'aktuell';
  if (gewaehlt === jetzt - 1) return 'vormonat';
  return 'sonstiges';
}

// Das Schuljahr beginnt im August: der 09.09.2026 liegt im Schuljahr 2026/2027.
export function schuljahrBeginn(heute = new Date()) {
  return heute.getMonth() >= 7 ? heute.getFullYear() : heute.getFullYear() - 1;
}

// Laufendes und kommendes Schuljahr, fuer die keine Ferien hinterlegt sind. Laufen die
// Ferien aus, zaehlt das System Ferientage still als normale Arbeitstage - deshalb warnen.
export function fehlendeFerienSchuljahre(eintraege, heute = new Date()) {
  const beginn = schuljahrBeginn(heute);
  return [beginn, beginn + 1].filter((jahr) => !(eintraege || []).some((e) => {
    const start = e && e.start ? String(e.start) : '';
    return start >= `${jahr}-08-01` && start <= `${jahr + 1}-07-31`;
  }));
}
